<template id="roleForm">    
    <div>                
        <div class="row">
            <div class="col-md-10">
                <h3>Role</h3>
            </div>
        </div>
        <form>
            
            <div class="row">
                <div class="col-md-8">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="role_title">Title</label>
                                <input type="text" class="form-control" v-model="form.title">
                                <form-error :isError="validateError.title.error" :errorMessage="validateError.title.message"></form-error>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="role_desc">Description</label>
                                <input type="text" class="form-control" v-model="form.desc">
                                <form-error :isError="validateError.desc.error" :errorMessage="validateError.desc.message"></form-error>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">                    
                        <label for="role_Permission">Permission</label>
                        <div class="row">
                            <div class="col-md-6" v-for="permission in permissions" v-bind:key="permission.id">
                                <div class="form-group">
                                    <input type="checkbox" v-model="form.permissions[permission.id].checked" class="form-controle"> {{permission.title}}
                                </div>
                            </div>
                        </div>
                        <form-error :isError="validateError.permissions.error" :errorMessage="validateError.permissions.message"></form-error>                    
                </div>                
            </div>            
            <div class="row">
                <div class="col-md-12 pt-5">
                    <div class="form-group float-right">
                        <a href="javascript:void(0)" onclick="javascript:window.history.back(); return false;" class="btn btn-secondary">ยกเลิก</a>
                        <button type="button" class="btn btn-primary ml-5" @click="saveWithGoBack()">บันทึก</button>
                        <button type="button" v-if="!this.item_id" class="btn btn-primary ml-5" @click="saveWithMore()">บันทึก และ บันทึกเพิ่ม</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props:{
            item_id:'', //เก็บ id ของ role กรณีที่เป็นการแก้ไข
        },
        components: {                
        },        
        data() {
            return {                
                form:{
                    title:'',
                    desc:'',
                    permissions:[],                    
                },
                validateError:{ 
                    // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
                    title:{error:false,message:''},
                    desc:{error:false,message:''},
                    permissions:{error:false,message:''},                    
                },
                permissions:{},
                roles:{}, //เพื่อเก็บและใช้ในตัวเลือก category_id  บนฟอร์ม
                base_url:'/role', // base url (เปลี่ยน)                
            }
        },
        mounted() {
        },
        created(){            
            
            this.fetchPermissions();
        },
        methods:{
            load(){

                console.log(this.item_id);
                axios.get(this.base_url+'/'+this.item_id)
                .then(response => {
                    // console.log(response.data.role[0]);
                    let role = response.data.role[0];
                    this.form.title = role.title;
                    this.form.desc = role.desc;                    
                    let me = this;                    
                    role.permission.forEach(function(item,idx){
                        me.form.permissions[item.id].checked = true;
                    });
                }).catch(errors => {
                    alert('loading role error', errors)
                    console.log(errors);
                });
            },
            saveWithGoBack(){
                this.save('');
            },            
            saveWithMore(){
                this.save('more');                
            },
            save(whatNext){
                let save_url = '';
                if(this.item_id!=''){
                    save_url = this.base_url+'/'+this.item_id+'/update';
                }else{
                    save_url = this.base_url;
                }

                let me = this;
                //console.log(this.form); 

                //เคลียร์ error ก่อนหน้า
                let fields = Object.keys(this.form);
                fields.forEach(function(item){
                    me.validateError[item].error = false;
                    
                });             
                
                console.log(this.form); //return;
                axios.post(save_url,this.form)
                .then(response => {
                    console.log(response);                    
                    if(whatNext=='more'){
                        // reload form
                        window.location.href = this.base_url+'/form';
                    }else{
                        // go back
                        window.location.href = this.base_url;
                    }
                }).catch(errors => {
                    if(errors.response.data.message){
                        let errorMessage = errors.response.data.message;                                               
                        let fields = Object.keys(this.form);
                        fields.forEach(function(item){
                            // console.log(item);
                            if(typeof errorMessage[item] !='undefined'){
                                me.validateError[item].error = true;
                                me.validateError[item].message = errorMessage[item][0];
                            }
                        });

                    }else{
                        console.log(errors.response.data._infos.result);
                        alert('ไม่สามารถบันทึกได้ '+ errors.response.data);
                    }
                })
                ;
            },
            fetchPermissions(url){
                url = url || '/permission/list';
                axios.get(url).then(response => {
                    this.permissions = response.data.items;                                            
                    // this.onRoleChanged(this.form.role_id);
                    let items = Object.entries(this.permissions);
                    console.log(items);
                    let me = this;
                    items.forEach(function(item,idx){
                        me.form.permissions[item[1].id] = {checked:false}
                    });

                    if(this.item_id){
                        this.load();
                    }
                })
                .catch(errors => {
                    console.log(errors);
                })
                ;
            },            
        },
    }
</script>